import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WindowsHero from './components/WindowsHero';
import WindowsServices from './components/WindowsServices';
import WindowsEnergy from './components/WindowsEnergy';
import WindowsProcess from './components/WindowsProcess';

const WINDOWS_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/windows-services#webpage`,
      url: `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/windows-services`,
      name: 'Instalación de Ventanas en Georgia | Ventanas de Alta Eficiencia – ORPM Investment LLC',
      description: 'Instalación y reemplazo profesional de ventanas de alta eficiencia energética en Georgia. Cotización gratuita. Ventanas de impacto y doble panel. Llama al +1 (561) 512-2820.',
      inLanguage: 'es-US',
      isPartOf: {
        '@type': 'WebSite',
        url: import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com',
        name: 'ORPM Investment LLC',
      },
    },
    {
      '@type': 'Service',
      '@id': `${import.meta.env.VITE_SITE_URL || 'https://orpminvestment.com'}/windows-services#service`,
      name: 'Instalación y Reemplazo de Ventanas',
      description: 'Servicio profesional de instalación y reemplazo de ventanas de alta eficiencia energética para hogares y negocios en Georgia.',
      provider: {
        '@type': 'LocalBusiness',
        name: 'ORPM Investment LLC',
        telephone: '+15615122820',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Lawrenceville',
          addressRegion: 'GA',
          postalCode: '30044',
          addressCountry: 'US',
        },
      },
      areaServed: {
        '@type': 'State',
        name: 'Georgia',
      },
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Servicios de Ventanas',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Instalación de Ventanas Nuevas',
              description: 'Instalación de ventanas nuevas de alta eficiencia energética en Georgia.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Reemplazo de Ventanas',
              description: 'Reemplazo de ventanas antiguas por modelos de doble panel de alta eficiencia.',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Ventanas de Impacto',
              description: 'Instalación de ventanas de impacto resistentes para mayor seguridad y protección.',
            },
          },
        ],
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '¿Cuánto cuesta la instalación de ventanas en Georgia?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'El costo varía según el tipo y cantidad de ventanas. Ofrecemos cotizaciones gratuitas sin compromiso. Contáctanos al +1 (561) 512-2820.',
          },
        },
        {
          '@type': 'Question',
          name: '¿Qué tipos de ventanas instalan en Georgia?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Instalamos ventanas de doble panel, ventanas de impacto, ventanas residenciales y comerciales, y ventanas de alta eficiencia energética en toda Georgia.',
          },
        },
      ],
    },
  ],
};

export default function WindowsServicesPage() {
  useEffect(() => {
    const id = 'schema-windows';
    let el = document.getElementById(id) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(WINDOWS_SCHEMA);
    document.title = 'Instalación de Ventanas en Georgia | ORPM Investment LLC';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', 'Instalación y reemplazo profesional de ventanas de alta eficiencia energética en Georgia. Cotización gratuita. Ventanas de impacto y doble panel. Llama al +1 (561) 512-2820.');
    return () => {
      const s = document.getElementById(id);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1" id="windows-form">
        <WindowsHero />
        <WindowsServices />
        <WindowsEnergy />
        <WindowsProcess />
      </main>
      <Footer />
    </div>
  );
}
